import type { ProductPricingType } from "types"
import { useUserV2 } from "./useUserV2"

type UseTypicalPriceReturnType = {
  typicalPrice: number
  customerGroup: "default" | "guest"
}

export const useTypicalPrice = (
  pricing?: ProductPricingType
): UseTypicalPriceReturnType => {
  const { isMember } = useUserV2()
  const isGuest = !isMember
  const typicalPrice = isGuest ? pricing?.guest : pricing?.typical

  const customerGroup = isGuest ? "guest" : "default"

  return {
    typicalPrice: typicalPrice ?? 0,
    customerGroup,
  }
}
